<div class="wrapper">
  <div class="header">
    <span
      class="backBtn clickable"
      (click)="onClose()"
      i18n="@@general.documents"
      ><img src="assets/Keen&Wise_back.png" /> Documents</span
    >
  </div>
  <div class="body">
    <app-document-viewer [pdf]="pdf"></app-document-viewer>
    <div class="buttons">
      <button
        *ngIf="canEditContacts"
        class="editContactBtn button customBtn"
        (click)="onOpenEditContactInfo()"
      >
        <img class="btnImg" src="assets/Keen&Wise_edit_round-138.png" />
        <span class="btnText" i18n="@@document.list.preview.edit.contactinfo"
          >edit contact info</span
        >
      </button>
      <button
        *ngIf="canPrintDocuments"
        class="printBtn button customBtn"
        (click)="onPrint()"
      >
        <img class="btnImg" src="assets/Print.svg" />
        <span class="btnText" i18n="@@general.print">print</span>
      </button>
    </div>
  </div>
</div>
